import { useEffect, useState } from "react";

import moment from "moment-timezone";

export const useNow = (intervalMs = 60_000) => {
  const [now, setNow] = useState(() => moment());

  useEffect(() => {
    const id = setInterval(() => setNow(moment()), intervalMs);
    return () => clearInterval(id);
  }, [intervalMs]);

  return now;
};
